let observer;
document.addEventListener("DOMContentLoaded", function () {
  let isProcessing = false;

  function getCurrentLanguage() {
    const domain = window.location.hostname;
    if (domain.includes("dk.toproset.eu")) return "dk";
    if (domain.includes("nl.toproset.eu")) return "nl";
    if (domain.includes("es.toproset.eu")) return "es";
    if (domain.includes("en.toproset.eu")) return "en";
    return "de";
  }

  const currentLanguage = getCurrentLanguage();

  const ENGRAVING_VARIANTS = {
    de: {
      pd_band: 51199965135197,
      pd_zentrum: 54581726347613,
      mfdd_zentrum: 51199965167965,
    },
    dk: {
      pd_band: 56263506461021,
      pd_zentrum: 56263401996637,
      mfdd_zentrum: 56263339442525,
    },
    en: {
      pd_band: 56263523565917,
      pd_zentrum: 56263426179421,
      mfdd_zentrum: 56263346127197,
    },
    es: {
      pd_band: 56263538868573,
      pd_zentrum: 56263449313629,
      mfdd_zentrum: 56263359824221,
    },
    nl: {
      pd_band: 55780492575069,
      pd_zentrum: 55780442964317,
      mfdd_zentrum: 55780472553821,
    },
  };

  const PROPERTY_NAMES = {
    de: {
      textOnRibbon: "Text auf",
      centerType: "Zentrumstyp",
      uploadImage: "Druckvorlage hochladen",
      imageText: "Druckvorlage",
    },
    dk: {
      textOnRibbon: "Tekst på",
      centerType: "Centertype",
      uploadImage: "Upload printskabelon",
      imageText: "Printskabelon",
    },
    en: {
      textOnRibbon: "Text on",
      centerType: "Center type",
      uploadImage: "Upload print template",
      imageText: "Template",
    },
    es: {
      textOnRibbon: "Texto en",
      centerType: "Tipo de centro",
      uploadImage: "Subir plantilla de impresión",
      imageText: "Impresión",
    },
    nl: {
      textOnRibbon: "Tekst op",
      centerType: "Type centrum",
      uploadImage: "Upload drukvoorbeeld",
      imageText: "Drukvoorbeeld",
    },
  };

  const PROPERTY_VALUES = {
    de: {
      centerTypePD: "Prägedruck auf Zentrum",
      centerTypeMDD: "Mehrfarbiger Digitaldruck",
    },
    dk: {
      centerTypePD: "Prægning på centrum",
      centerTypeMDD: "Flerfarvet digitaltryk",
    },
    en: {
      centerTypePD: "Embossed print on center",
      centerTypeMDD: "Multicolor digital print",
    },
    es: {
      centerTypePD: "Impresión en relieve en el centro",
      centerTypeMDD: "Impresión digital multicolor",
    },
    nl: {
      centerTypePD: "Reliëfdruk op centrum",
      centerTypeMDD: "Meerkleurige digitale druk",
    },
  };

document.addEventListener("DOMContentLoaded", () => {
    const cartContainer = document.querySelector("#cart-container");

    if (cartContainer) {
        const observer = new MutationObserver((mutations) => {
            let updateNeeded = false;

            mutations.forEach(mutation => {
                if (mutation.type === "attributes" && mutation.attributeName === "data-quantity") {
                    const itemKey = mutation.target.getAttribute("data-product-id");

                    if (itemKey) {
                        updateNeeded = true;  // We mark that the cart needs to be updated
                    }
                }
            });

            if (updateNeeded) {
                /// console.log("🔄 Cart checking...");
                getCartData().then(cart => {
                    cart.items.forEach(item => {
                        if (item.properties?._auto_added !== "true") {
                           // console.log(`✅ Renew  parent product: ${item.key}`);
                            updateCartForEngravings().then(() => refreshCartUI());
                        }
                    });
                }).catch(error => {
                   /// console.error("❌ Cart checking error:", error);
                });
            }
        });

        observer.observe(cartContainer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["data-quantity"],
        });

        //console.log("👀 Observation enabled");
    }
});


async function getCartData(delay = 500) {
    try {
        // Delay before request
        if (delay) await new Promise(resolve => setTimeout(resolve, delay));

        const response = await fetch(`/cart.js?timestamp=${Date.now()}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0"
            },
            cache: "no-store"
        });

        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error("❌ Error fetching cart:", error);
        return null;
    }
}

async function simulateQuantityChange(itemKey, newQuantity) {
    // : selector
    const safeKey = itemKey.replace(/:/g, "\\:");
    const inputField = document.querySelector(`#updates_${safeKey}`);

    if (inputField) {
        // Value proof
        if (parseInt(inputField.value, 10) === newQuantity) {
            //console.log(`✅ Value for ${itemKey} are equal ${newQuantity}, no changes needed.`);
            return;
        }

        // Chanhge value and input emulation
        inputField.value = newQuantity;
        inputField.dispatchEvent(new Event('input', { bubbles: true }));
        inputField.dispatchEvent(new Event('change', { bubbles: true }));

        //console.log(`📝Input emulated: product ${itemKey}, new qty: ${newQuantity}`);

        //  renew with AJAX
        try {
            const response = await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: itemKey, quantity: newQuantity })
            });

            if (!response.ok) throw new Error("AJAX renew error.");
           // console.log(`🔄 AJAX: Product ${itemKey} qty ${newQuantity}`);
        } catch (error) {
            console.error(`❌ Product ${itemKey} is not renewed AJAX:`, error);
        }
    } else {
        console.warn(`⚠️ Input field for product with key ${itemKey} not found.`);
    }
}
async function waitForCartUpdate(itemKey, expectedQuantity, timeout = 5000) {
    const startTime = Date.now();

    while ((Date.now() - startTime) < timeout) {
        const cart = await getCartData();
        const item = cart.items.find(i => i.key === itemKey);

        if (item && item.quantity === expectedQuantity) {
           //console.log(`✅ Cart renewed sucsesfull: ${itemKey} = ${expectedQuantity}`);
            return true;
        }

        //console.log(`⏳ Weiting for cart renew... ${itemKey} (weit: ${expectedQuantity})`);
        await new Promise(resolve => setTimeout(resolve, 500));  // Weit 500 ms befor check
    }

    //console.warn(`⚠️ Time is out for renew product with key ${itemKey}`);
    return false;
}

  
async function updateCartForEngravings() {
    let loader = document.getElementById("ajaxBusy");
    let cartChanged = false;
    const cartContainer = document.querySelector("#cart-container");

    try {
        if (observer && cartContainer) observer.disconnect();
        if (loader) loader.style.display = "block";
        if (isProcessing) return;
        isProcessing = true;

        const cart = await getCartData();
        if (!cart) return;

        const properties = PROPERTY_NAMES[currentLanguage];
        const engravingItems = {};
        const zentrumItems = {};
        const existingEngravings = {};
        const existingZentrum = {};
        let updateItems = [];

        // We get all the keys of parent products
        const parentProductKeys = new Set();

        // Parent Product Analysis
        const excludedSkus = ["20054", "20050", "20056S", "20056K", "20071"];
        for (const item of cart.items) {
            if (item.properties?._auto_added === "true" || excludedSkus.includes(item.sku)) continue; //if (item.properties?._auto_added === "true") continue;

            parentProductKeys.add(item.key);

            const quantity = item.quantity;

            Object.entries(item.properties || {}).forEach(([key, value]) => {
                if (key.startsWith(properties.textOnRibbon) && value?.trim()) {
                    const text = value.trim();
                    if (!engravingItems[text]) engravingItems[text] = { quantity: 0, parents: new Set() };
                    engravingItems[text].quantity += quantity;
                    engravingItems[text].parents.add(item.key);
                }
            });

            if (item.properties?.[properties.centerType] && item.properties?.[properties.uploadImage]) {
                const imageUrl = item.properties[properties.uploadImage];
                //const isPD = item.properties[properties.centerType] === PROPERTY_VALUES[currentLanguage].centerTypePD;
                const isPD = item.properties[properties.centerType]?.trim() === PROPERTY_VALUES[currentLanguage].centerTypePD;
                const type = isPD ? "pd_zentrum" : "mfdd_zentrum";
                const hash = await getImageHash(imageUrl);
// test
                console.log("🖼️ Zentrum found:", {
                  imageUrl,
                  type,
                  isPD,
                  centerType: item.properties[properties.centerType],
                  expected: PROPERTY_VALUES[currentLanguage].centerTypePD,
                  hash
                });
// end test              
                if (hash) {
                    const uniqueKey = `${hash}|${type}`;
                    if (!zentrumItems[uniqueKey]) {
                        zentrumItems[uniqueKey] = { quantity: 0, type, imageUrl, parents: new Set() };
                    }
                    zentrumItems[uniqueKey].quantity += quantity;
                    zentrumItems[uniqueKey].parents.add(item.key);
                }
            }
        }

        // Identification of existing related products
        for (const item of cart.items) {
            if (item.properties?._auto_added === "true") {
                const text = item.properties?.Text;
                const imageUrl = item.properties?.[properties.uploadImage];
                const parentKeys = (item.properties?._parent_keys || "").split(",").filter(Boolean);
                const type = item.variant_id === ENGRAVING_VARIANTS[currentLanguage].pd_zentrum
                    ? "pd_zentrum"
                    : item.variant_id === ENGRAVING_VARIANTS[currentLanguage].mfdd_zentrum
                        ? "mfdd_zentrum"
                        : null;

                if (item.variant_id === ENGRAVING_VARIANTS[currentLanguage].pd_band && text) {
                    existingEngravings[text] = { key: item.key, quantity: item.quantity, parentKeys };
                }

                if (imageUrl && type) {
                    const hash = await getImageHash(imageUrl);
                    if (hash) {
                        const uniqueKey = `${hash}|${type}`;
                        existingZentrum[uniqueKey] = { key: item.key, quantity: item.quantity, type, imageUrl, parentKeys };
                    }
                }
            }
        }

        // Updating/removing engravings
        for (const [text, { quantity, parents }] of Object.entries(engravingItems)) {
            const parentKeys = Array.from(parents);
            if (existingEngravings[text]) {
                if (existingEngravings[text].quantity !== quantity) {
                    updateItems.push({ id: existingEngravings[text].key, quantity });
                    cartChanged = true;
                }
            } else {
                await addEngravingToCart(text, quantity, parentKeys);
                cartChanged = true;
            }
        }

        for (const [text, engraving] of Object.entries(existingEngravings)) {
            const allParentsRemoved = engraving.parentKeys.every(key => !parentProductKeys.has(key));
            if (!engravingItems[text] || allParentsRemoved) {
                updateItems.push({ id: engraving.key, quantity: 0 });
                cartChanged = true;
            }
        }

        // Updating/removing centers
        for (const [uniqueKey, { quantity, type, imageUrl, parents }] of Object.entries(zentrumItems)) {
            const parentKeys = Array.from(parents);
            if (existingZentrum[uniqueKey]) {
                if (existingZentrum[uniqueKey].quantity !== quantity) {
                    updateItems.push({ id: existingZentrum[uniqueKey].key, quantity });
                    cartChanged = true;
                }
            } else {
                await addZentrumToCart(imageUrl, quantity, type, parentKeys);
                cartChanged = true;
            }
        }

        for (const [uniqueKey, zentrum] of Object.entries(existingZentrum)) {
            const allParentsRemoved = zentrum.parentKeys.every(key => !parentProductKeys.has(key));
            if (!zentrumItems[uniqueKey] || allParentsRemoved) {
                updateItems.push({ id: zentrum.key, quantity: 0 });
                cartChanged = true;
            }
        }

        // Cart update
        if (updateItems.length > 0) {
            const updates = updateItems.reduce((acc, { id, quantity }) => {
                acc[id] = quantity;
                return acc;
            }, {});

            await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates })
            });
        }

    } catch (error) {
        console.error("❌ Cart update error:", error.message || error);
    } finally {
        if (loader) loader.style.display = "none";
        isProcessing = false;

        setTimeout(() => {
            if (observer && cartContainer) {
                observer.observe(cartContainer, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ["data-quantity"],
                });
            }
        }, 500);

        await refreshCartUI(cartChanged ? 1000 : 0);
    }
}

async function addEngravingToCart(text, quantity, parentKeys = []) {
    try {
        await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: ENGRAVING_VARIANTS[currentLanguage].pd_band,
                quantity,
                properties: {
                    Text: text,
                    _auto_added: "true",
                    _parent_keys: parentKeys.join(",")
                }
            }),
        });
    } catch (error) {
        console.error("❌ Error adding engraving:", error);
    }
}

async function addZentrumToCart(imageUrl, quantity, type, parentKeys = []) {
    try {
        const properties = PROPERTY_NAMES[currentLanguage];
        await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: ENGRAVING_VARIANTS[currentLanguage][type],
                quantity,
                properties: {
                    [properties.uploadImage]: imageUrl,
                    _auto_added: "true",
                    _parent_keys: parentKeys.join(",")
                }
            }),
        });
    } catch (error) {
        console.error("❌ Error adding zentrum:", error);
    }
}


  
async function updateCartItem(itemKey, quantity) {
    try {
        //console.log(`🛒 Changing the quantity of goods ${itemKey} - ${quantity}...`);

        const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: itemKey, quantity }),
        });

        if (!response.ok) throw new Error("Changing the quantity of goods ERROR.");

        // Waiting for confirmation of cart update
        const updated = await waitForCartUpdate(itemKey, quantity);

        if (updated) {
            //console.log(`✅ Changing the quantity of goods key ${itemKey} success ${quantity}`);
            await updateCartForEngravings();
        } else {
            //console.warn(`⚠️ Cart update error for ${itemKey}`);
        }
    } catch (error) {
        console.error("❌ Changing the quantity of goods:", error);
    }
}



async function checkAndGroupImages(zentrumItems) {
    let imageInfo = {};    // { "imageHash|type": { width, height, format, hash, type, quantity, url } }
    let groupedItems = {}; // { "uniqueImageKey": { quantity, type, url } }

    for (let imageUrl of Object.keys(zentrumItems)) {
        let { quantity, type } = zentrumItems[imageUrl];
        let cleanImageUrl = imageUrl.split('|')[0];

        try {
            let img = await loadImage(cleanImageUrl);
            let { width, height, format } = img;
            let hash = await getImageHash(cleanImageUrl);

            if (!hash) continue;

            let uniqueKey = `${hash}|${type}`;

            if (imageInfo[uniqueKey]) {
                console.log(`✅ Is loaded: ${cleanImageUrl} with type ${type}`);
                imageInfo[uniqueKey].quantity += quantity;
                continue;
            }

            // Searchin for similar images
            let existingImage = Object.values(imageInfo).find(
                (img) =>
                    img.width === width &&
                    img.height === height &&
                    img.format === format &&
                    img.type === type
            );

            if (existingImage) {
                let hash1 = hash;
                let hash2 = existingImage.hash;

                if (hash1 === hash2) {
                    //console.log(`🔄 Similar images: ${cleanImageUrl} and ${existingImage.url} (Type: ${type})`);

                    let existingKey = Object.keys(groupedItems).find(
                        (key) => groupedItems[key].url === existingImage.url && groupedItems[key].type === type
                    );

                    if (existingKey) {
                        groupedItems[existingKey].quantity += quantity;
                        continue;
                    }
                }
            }

            imageInfo[uniqueKey] = { width, height, format, hash, type, quantity, url: cleanImageUrl };
            groupedItems[uniqueKey] = { quantity, type, url: cleanImageUrl };

        } catch (error) {
            console.error(`❌ Error image loading: ${cleanImageUrl}`, error);
        }
    }

    return groupedItems;
}


async function loadImage(url) {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
            let format = url.split(".").pop().toLowerCase();
            resolve({ width: img.width, height: img.height, format, url });
        };
        img.onerror = reject;
        img.src = url;
    });
}
  
async function getImageHash(url) {
    try {
        let response = await fetch(url);
        let buffer = await response.arrayBuffer();
        let hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
        return Array.from(new Uint8Array(hashBuffer)).map(b => b.toString(16).padStart(2, "0")).join("");
    } catch (error) {
        console.error(`❌ Error cache calculating ${url}`, error);
        return null;
    }
}

async function waitForCartSync(expectedItems, timeout = 5000, interval = 500) {
    const startTime = Date.now();

    while (Date.now() - startTime < timeout) {
        const cart = await getCartData();

        // Checking for compliance with expected goods and quantities
        const allSynced = expectedItems.every(expected => {
            const actual = cart.items.find(item => item.key === expected.key);
            return actual && actual.quantity === expected.quantity;
        });

        if (allSynced) {
            //console.log("✅ The cart has been synchronized.");
            return true;
        }

        console.log("🔄 Waiting for cart to sync...");
        await new Promise(resolve => setTimeout(resolve, interval));
    }

    console.warn("⚠️ Cart synchronization timed out.");
    return false;
}

 async function waitForElement(selector, timeout = 5000) {
    const startTime = Date.now();
    while (Date.now() - startTime < timeout) {
        const element = document.querySelector(selector);
        if (element) return element;
        await new Promise(resolve => setTimeout(resolve, 200));
    }
    console.warn(`⚠️ Element ${selector} не not found within ${timeout} ms.`);
    return null;
}

  async function refreshCartUI(expectedItems = [], delay = 500) {
    try {
        // ✅ Wait for the cart to sync if the expected items are specified
        if (expectedItems.length > 0) {
            const synced = await waitForCartSync(expectedItems);
            if (!synced) {
                console.warn("⚠️ The cart is not synchronized in time.");
            }
        }

        // ⏳ A small delay for stability
        if (delay) await new Promise(resolve => setTimeout(resolve, delay));

        // 📥 Getting HTML of the cart
        const response = await fetch("/cart");
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

        const html = await response.text();

        // ✅ Using CartReload to update the interface
        if (window.location.pathname.includes("/cart")) {
          CartReload(html);
        }
        CartReload(html); //?

        //console.log("✅ The cart interface has been successfully updated via CartReload");

        // 🔑 Re-initialize handlers
        if (typeof initCartHandlers === "function") {
            initCartHandlers();
            //console.log("✅ The cart handlers have been successfully restarted.");
        }
    } catch (error) {
        console.error("❌Error updating cart interface:", error);
    }
}



// Updated handlers for + and - buttons
  function initCartHandlers() {
    document.querySelectorAll(".qtyminus_multi, .qtyplus_multi").forEach((button) => {
        button.addEventListener("click", async () => {
            console.log(`🔄 The button is pressed ${button.classList.contains("qtyminus_multi") ? "-" : "+"}`);

            // ⏳ Wait for a short pause for Shopify to process the change
            setTimeout(async () => {
                //console.log("🐀񓑇etting updated cart status...");

                // Requesting the current state of the basket
                const cart = await getCartData();

                if (cart && cart.items.length > 0) {
                    //console.log("✅ Cart updated. Recalculating related products...");
                    await updateCartForEngravings();
                    await refreshCartUI();
                } else {
                    console.warn("⚠️ The cart is empty or not updated.");
                }
            }, 1000); // 1 second is the optimal time to update Shopify
        });
    });
}


async function handleQuantityChange(event) {
    if (isProcessing) return;
    isProcessing = true;

    const input = event.target;
    const newQuantity = parseInt(input.value);
    const itemKey = input.getAttribute("id").replace("updates_", "");

    if (!itemKey) {
        console.error("❌ Failed to get product key.");
        isProcessing = false;
        return;
    }

    try {
        const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: itemKey, quantity: newQuantity }),
        });

        if (!response.ok) throw new Error("Error when changing the quantity of goods.");

        console.log(`✅Quantity of goods with key ${itemKey} updated to ${newQuantity}`);
        location.reload();  // 🌟 Reboot after change
    } catch (error) {
        console.error("❌ Error changing quantity:", error);
    } finally {
        isProcessing = false;
    }
}

/*
  document.addEventListener("input", function (event) {
   if (event.target && event.target.classList.contains("item-qty")) {
    console.log(
    //"🔄 The quantity of the main product has been changed, we are updating related products..."
   );
            updateCartForEngravings().then(() => refreshCartUI());
        }
    });
*/
// ✅ Focus
document.addEventListener("blur", function (event) {
  if (event.target && event.target.classList.contains("item-qty")) {
    updateCartForEngravings().then(() => refreshCartUI());
  }
}, true); // 

// ✅ Enter
document.addEventListener("keydown", function (event) {
  if (event.key === "Enter" && event.target.classList.contains("item-qty")) {
    event.preventDefault(); // 🛑 cancel transition to cart
    updateCartForEngravings().then(() => refreshCartUI());
  }
});
  
    // Handling the + and - buttons
    document.addEventListener("click", function (event) {
        if (event.target && (event.target.classList.contains("qtyminus_multi") || event.target.classList.contains("qtyplus_multi"))) {
            const input = event.target.closest(".quantity").querySelector(".item-qty");
            if (input) {
                //let value = parseInt(input.value, 10) || 0;
                //const change = event.target.classList.contains("qtyminus_multi") ? -1 : 1;
                //const newValue = Math.max(0, value + change);
                //input.value = newValue;

                //console.log(`🔄  ${event.target.className}, new value: ${newValue}`);
                updateCartForEngravings().then(() => refreshCartUI());
            }
        }
    });


updateCartForEngravings().then(() => refreshCartUI());

document.addEventListener("DOMContentLoaded", () => {
    const cartContainer = document.querySelector("#cart-container");

    if (cartContainer) {
        const observer = new MutationObserver((mutations) => {
            if (!isProcessing && mutations.some(m => m.type === 'childList' || m.type === 'attributes')) {
                console.log("🔄 Changes detected in the cart.");
                updateCartForEngravings().then(() => refreshCartUI());
            }
        });

        observer.observe(cartContainer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-quantity']
        });

       // console.log("👀 Cart monitoring is enabled.");
    }

    //Intercepting AJAX requests
    (function(open) {
        XMLHttpRequest.prototype.open = function(method, url, async, user, pass) {
            this.addEventListener('load', function() {
                if (url.includes('/cart/change.js') || url.includes('/cart/update.js')) {
                    console.log("🛒 AJAX request to update the cart.");
                    updateCartForEngravings().then(() => refreshCartUI());
                }
            });
            open.call(this, method, url, async, user, pass);
        };
    })(XMLHttpRequest.prototype.open);

    console.log("🚀 AJAX request interception is enabled.");
});
});